export default __webpack_public_path__ + "static/media/default-profile.2f0afa0b.svg";